const PURGE_WARNING_PERIOD_MS = 30 * 24 * 60 * 60 * 1000;

/** An overdue purge date counts as approaching. */
const isPurgeApproaching = (purgeScheduledAt: Date | null): boolean =>
	purgeScheduledAt !== null && purgeScheduledAt.getTime() - Date.now() <= PURGE_WARNING_PERIOD_MS;

export default isPurgeApproaching;
